import {
  Stack,
  Typography,
  MenuList,
  Popover,
  useTheme,
  ListItemText,
  Autocomplete,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import { FormProvider, RHFTextField, Scrollbar } from '@app/components';
import { CustomAvatar } from '@app/components/custom-avatar';
import { Strings } from '@app/constants';
import { useRequestState } from '@app/hooks';
import { selectSearchUserState } from '@app/modules/reviews/selecter';
import { searchUser } from '@app/modules/reviews/slice';

interface Props {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  handleClose: () => void;
  selectedMembers?: string[];
  addSelectedMember?: (name: string) => void;
  searchProps: any;
}

const MemberListPopover = ({
  open,
  anchorEl,
  handleClose,
  selectedMembers,
  addSelectedMember,
  searchProps,
}: Props) => {
  const theme = useTheme();
  const id = open ? 'simple-popover' : undefined;
  const [query, setQuery] = useState();
  const dispatch = useDispatch();
  const methods = useForm();

  useEffect(() => {
    dispatch(searchUser(query));
  }, [dispatch, query]);

  const { data } = useRequestState({
    stateSelector: selectSearchUserState,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          sx={{
            '& .MuiPaper-root': {
              width: '300px',
              height: '50%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            },
          }}
        >
          <Stack sx={{ alignItems: 'center' }}>
            <Typography>{Strings.taskBoard.members}</Typography>
          </Stack>
          <Stack p={2}>
            <Autocomplete
              options={data?.map((option: any) => ({
                label: option.firstName,
                id: option.id,
              }))}
              onChange={(event: any, value: any) => {
                setQuery(event.target.value);
              }}
              renderInput={(params: any) => (
                <RHFTextField {...params} name="search" label={Strings.common.search} fullWidth />
              )}
            />
          </Stack>
          <Scrollbar>
            <Stack ml={2}>
              {data?.map((manager: any, index: number) => (
                <MenuList
                  key={index}
                  onClick={() => {
                    addSelectedMember?.(manager.firstName);
                  }}
                  sx={{
                    backgroundColor: selectedMembers?.includes(manager.firstName)
                      ? theme.palette.grey[300]
                      : theme.palette.grey[200],
                    borderRadius: '14px',
                    mb: 0.5,
                    pl: 1,
                    mr: 0.5,
                  }}
                >
                  <Stack
                    sx={{
                      flexDirection: 'row',
                    }}
                    gap={2}
                  >
                    <CustomAvatar name={manager.firstName || 'NA'} color="info" />
                    <Stack sx={{ alignSelf: 'center' }}>
                      <ListItemText primary={manager.firstName} />
                    </Stack>
                  </Stack>
                </MenuList>
              ))}
            </Stack>
          </Scrollbar>
        </Popover>
      </FormProvider>
    </>
  );
};

export { MemberListPopover };
